import { render } from "./BoosterIncome.vue?vue&type=template&id=76c3b50b&scoped=true"
import script from "./BoosterIncome.vue?vue&type=script&lang=js"
export * from "./BoosterIncome.vue?vue&type=script&lang=js"

import "./BoosterIncome.vue?vue&type=style&index=0&id=76c3b50b&scoped=true&lang=css"

import exportComponent from "/home/tarun/Downloads/sunlight replica  vuejs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76c3b50b"]])

export default __exports__